import { ReactNode } from "react";

interface FieldProps {
  label: ReactNode;
  disabled?: boolean;
  value: string;
  children: ReactNode;
}

/** Plain text when disabled, the editable control otherwise. */
export function Field({ label, disabled, value, children }: FieldProps) {
  return (
    <div>
      <label>{label}</label>
      {disabled ? <p className="body-sm text-grey-900">{value || "—"}</p> : children}
    </div>
  );
}
